import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Badge, Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const StyledOnboardingModal = styled(Flex)`
    flex-direction: column;
    height: 100%;
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 8px;
    overflow: hidden;
`;

export const StyledModalContent = styled(Flex)`
    flex: 1;
    padding: 40px 40px 60px;
    overflow-y: auto;
    flex-direction: column;
`;

export const StyledModalFooter = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledScreenWrapper = styled(Flex)`
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const StyledScreenTitle = styled(Text)`
    margin-bottom: 16px;
`;

export const StyledScreenDescription = styled(Text)`
    width: 85%;
`;

export const StyledIllustration = styled.div`
    margin-top: 35px;
`;

export const StyledRobotIllustration = styled.div`
    margin-top: 48px;
`;

export const UseCaseContainer = styled(Flex)`
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 38px;
`;

export const TileStyled = styled(Flex)<{ isSelected: boolean }>`
    position: relative;
    flex-direction: row;
    justify-content: center;
    padding: 15px 10px;
    width: 350px;
    margin-bottom: 12px;
    border: 1px solid ${({ isSelected }) => (isSelected ? colorsPalettes.blue[400] : colorsPalettes.carbon[100])};
    border-radius: 50px;
    filter: none;
    cursor: pointer;
`;

export const TileContainer = styled(Flex)`
    align-items: center;
`;

export const Title = styled(Flex)`
    justify-content: center;
`;

export const DefaultTile = styled(Badge)`
    position: absolute;
    top: -9px;
    right: 21px;
    border-radius: 16px;
    padding: 4px 6px;
`;

export const ImportantContainer = styled(Flex)`
    margin-top: 16px;
    background-color: ${colorsPalettes.yellow[100]};
    padding: 8px 11px;
`;

export const ErrorContainer = styled(Flex)`
    align-items: center;
    gap: 4px;
`;

export const SkipButtonContainer = styled(Flex)`
    align-items: center;
`;

export const NextButtonStyled = styled(Button)`
    margin-left: 4px;
`;

export const ButtonsContainer = styled(Flex)`
    align-items: center;
    margin-left: auto;
`;
